<template>
  <div style="width:100%;">
    <div class="upload-name" style="width:100%;">
      <input v-model="imgName" disabled="disabled" />
      <button
        v-if="img != null || saveData.imgName"
        class="resetButton"
        @click="resetFile"
        style="border: none; display:inline-flex"
      >
        <font-awesome-icon icon="times-circle" style="font-size:20px" />
      </button>
    </div>
    <label for="img" style="white-space: nowrap;">업로드</label>
    <input type="file" id="img" class="upload-hidden" @change="setImgName" />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["saveData"],
  data() {
    return {
      img: null,
    };
  },
  computed: {
    imgName() {
      if (this.img) {
        this.saveData.imgName = this.img.name;
        return this.img.name;
      } else if (this.saveData.imgName) {
        return this.saveData.imgName;
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapActions("file", ["requestDeleteByFileGroupId"]),
    resetFile() {
      if (this.img) {
        this.img = null;
        this.saveData.img = null;
      } else if (this.saveData.imgName) {
        var response = this.$createConfirmResponse();
        this.$confirm(
          "알림",
          `업로드된 첨부파일을 삭제하시겠습니까?`,
          "확인",
          "취소",
          response,
          {
            closed: () => {
              if (response.result) {
                this.requestDeleteByFileGroupId(this.saveData.imgGroupId)
                  .then(() => {
                    this.$alert("알림", "첨부파일이 삭제되었습니다.", "", {
                      closed: () => {
                        this.$router.go();
                      },
                    });
                  })
                  .catch(() => {
                    this.$alert("알림", "첨부파일을 삭제할 수 없습니다.");
                  });
              }
            },
          }
        );
      }
    },
    setImgName(event) {
      let imgName = event.target.files[0].name;

      let imgNameArr = imgName.split(".");
      let ext = imgNameArr[imgNameArr.length - 1];

      let checkExts = [
      "png",
        "jpg",
        "jpeg",
        "PNG",
        "JPG",
        "JPEG",
      ];

      var check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. <br>(png, jpg, jpeg 파일만 업로드할 수 있습니다.)"
        );
        return;
      }

      var maxSize = 10 * 1024 * 1000;
      if (event.target.files[0].size > maxSize) {
        this.$alert("알림", "첨부파일은 10mb이하의 크기만 업로드 가능합니다.");
        return;
      }

      this.img = event.target.files[0];
      this.$emit("set-file", this.img);
    },
  },
};
</script>

<style scoped lang="scss">
.resetButton {
  color: #989898;
  cursor: pointer;
}
.resetButton:hover {
  color: #2d2d2d;
}
</style>
